export enum HoursActions {
  Reset = "reset",
  FetchHours = "fetchHours",
  FetchCourseHours = "fetchCourseHours",
  UpdateHour = "updateHour",
}
